module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "full-box"
  }, [_c('div', {
    staticClass: "loadingWorkOrders"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v("\n      Loading Photos for Work Order #" + _vm._s(this.$route.params.id) + "        \n    ")])]) : _vm._e(), _vm._v(" "), (_vm.openMenu) ? [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close-menu",
    on: {
      "click": function($event) {
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('button', {
    staticClass: "pull-right btn header-btn mcBG scBGHover",
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Back to the Work Order")])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.showMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-header-bar mcBG"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('h1', [_vm._v("Add Photos "), _c('span', [_vm._v("[WO# " + _vm._s(_vm.workOrder) + "]")])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('h1', [_vm._v("Add Photos - WO# " + _vm._s(_vm.workOrder) + " ")])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', {
    staticClass: "tablet-view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexrow"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v("Work Order is closed")]), _vm._v(" "), _vm._m(1)] : _vm._e(), _vm._v(" "), (!_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v(_vm._s(_vm.leftTitle))]), _vm._v(" "), (_vm.canTakePics) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fileInput"
    }
  }, [_vm._v("Select Photo")]), _vm._v(" "), _c('image-uploader', {
    attrs: {
      "debug": 2,
      "maxWidth": 1024,
      "maxHeight": 1024,
      "quality": 0.9,
      "autoRotate": false,
      "outputFormat": "string",
      "preview": true,
      "className": ['fileinput', {
        'fileinput--loaded': _vm.hasImage
      }]
    },
    on: {
      "input": _vm.setImage,
      "onUpload": _vm.startImageResize,
      "onComplete": _vm.endImageResize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPhotoSave),
      expression: "showPhotoSave"
    }],
    staticClass: "mcBG scBGHover btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyUploading),
      expression: "busyUploading"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n                Uploading & Optimizing Photo "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busySaving),
      expression: "busySaving"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._v("\n                Saving New Photo to the Database "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitError),
      expression: "submitError"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.submitErrorText) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (!_vm.canTakePics) ? _c('div', [_vm._m(2)]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "inner-dark"
  }, [_c('h3', {
    staticClass: "mcText"
  }, [_c('span', [_vm._v("Username")]), _vm._v("\n            " + _vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('br'), _c('br')])])])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('div', {
    staticClass: "mobile-view"
  }, [_c('div', {
    staticClass: "lem-formTop"
  }, [(_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v("Work Order is closed")]), _vm._v(" "), _vm._m(3)] : _vm._e(), _vm._v(" "), (!_vm.workOrderCheck.fieldComplete) ? [_c('h2', [_vm._v(_vm._s(_vm.leftTitle))]), _vm._v(" "), (_vm.canTakePics) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fileInput"
    }
  }, [_vm._v("Select Photo")]), _vm._v(" "), _c('image-uploader', {
    attrs: {
      "debug": 2,
      "maxWidth": 1024,
      "maxHeight": 1024,
      "quality": 0.9,
      "autoRotate": false,
      "outputFormat": "string",
      "preview": true,
      "className": ['fileinput', {
        'fileinput--loaded': _vm.hasImage
      }]
    },
    on: {
      "input": _vm.setImage,
      "onUpload": _vm.startImageResize,
      "onComplete": _vm.endImageResize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPhotoSave),
      expression: "showPhotoSave"
    }],
    staticClass: "mcBG scBGHover btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.buttonTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyUploading),
      expression: "busyUploading"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busySaving),
      expression: "busySaving"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._m(5)])]) : _vm._e(), _vm._v(" "), (!_vm.canTakePics) ? _c('div', [_vm._m(6)]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "lem-dividingCount"
  }, [_vm._v("\n        " + _vm._s(_vm.photoRecords.length) + " Records\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "lem-listingBottom"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busyDel),
      expression: "busyDel"
    }],
    staticClass: "statusMSG form-group"
  }, [_vm._m(7)])])])]) : _vm._e(), _vm._v(" "), _c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("    " + _vm._s(_vm.$data) + "\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-image"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("This Work Order is closed, so you will not be able to add any new "), _c('strong', [_vm._v("photos")]), _vm._v(" or delete any existing photos.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Your user cannot upload new photos to this Work Order.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("This Work Order is closed, so you will not be able to add any new "), _c('strong', [_vm._v("photos")]), _vm._v(" or delete any existing photos.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Uploading & Optimizing Photo "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Saving New Photo to the Database "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Your user cannot upload new photos to this Work Order.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Deleting Photo "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71e88250!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photos.vue
// module id = 860
// module chunks = 2